<template>
<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg" @click="$emit('click')">
  <rect x="0.75" y="1.59131" width="22.5" height="16.5" rx="1.25" fill="white" stroke="#9FAAB6" stroke-width="1.5"/>
  <path d="M8.35938 7.22803H6.14258V13.3413H4.91699V7.22803H2.71973V6.23193H8.35938V7.22803ZM11.7932 8.80029L13.2873 6.23193H14.7131L12.5646 9.75732L14.7619 13.3413H13.3215L11.7932 10.7339L10.26 13.3413H8.82441L11.0266 9.75732L8.87324 6.23193H10.299L11.7932 8.80029ZM20.8617 7.22803H18.6449V13.3413H17.4193V7.22803H15.2221V6.23193H20.8617V7.22803Z" fill="#9FAAB6"/>
</svg>
</template>

<script>
export default {
  name: 'icon-txt'
}
</script>
